<template>
  <div class="service-code-badges">
    <div v-for="badge in badges" :key="badge.fullName" v-bind:class="{'badge': true}">
      <div class="text-left">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-chip small label v-on="on">{{ badge.code }}<span v-if="badge.quantity > 1">&nbsp;({{ badge.quantity }})</span></v-chip>
          </template>
          <span>{{ badge.fullName }}</span>
        </v-tooltip>
      </div>
    </div>
    <div class="clear-both"></div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'service-code-badges',
  filters: {},
  props: {
    servicesById: {
      type: Object
    },
    caseServices: {
      type: Array
    }
  },
  computed: {
    badges () {
      let result = []
      for (let caseService of this.caseServices) {
        let service = _.get(this.servicesById, caseService.serviceId, null)

        if (service == null) {
          continue
        }

        result.push({
          code: service.code,
          fullName: service.title,
          quantity: caseService.quantity,
        })
      }

      return result
    }
  }
}
</script>

<style scoped>
  .service-code-badges .chip--small {
    height: 22px;
  }

  .service-code-badges .chip--content {
    padding: 0 6px;
  }

  .service-code-badges ul {
    list-style-type: none;
  }

  .service-code-badges .badge {
    float:left;
  }

  .service-code-badges .clear-both {
    clear:both;
  }

  .service-code-badges .client-code {
    font-size: 10px;
  }
</style>
